import {
	GriffelStyle,
	makeStyles,
	shorthands,
	tokens,
} from "@fluentui/react-components";

export const ellipsis = (): GriffelStyle => ({
	textOverflow: "ellipsis",
	...shorthands.overflow("hidden"),
	whiteSpace: "nowrap",
});

export const ellipsisMultiline = (numberOfLines: number): GriffelStyle => ({
	...shorthands.overflow("hidden"),
	display: "-webkit-box",
	"-webkit-box-orient": "vertical",
	"-webkit-line-clamp": numberOfLines.toString(),
});

export const semiBold = (): GriffelStyle => ({
	fontWeight: tokens.fontWeightSemibold,
});

export const containerHighlight = (borderWidth: number = 2): GriffelStyle => ({
    border: `${borderWidth}px solid ${tokens.colorNeutralForeground2BrandHover}`,
    boxShadow: "inset 0 0 3px rgba(43, 120, 245, 0.5)",
});

export const containerHighlightDark = (): GriffelStyle => containerHighlight(4);

export const dragOverHighlight = (): GriffelStyle => ({
	position: "absolute",
	top: 0,
	left: 0,
	right: 0,
	bottom: 0,
	backgroundColor: `color-mix(in srgb, ${tokens.colorBrandBackground2} 50%, transparent)`,
	border: `2px solid ${tokens.colorBrandStroke1}`,
	borderRadius: "4px",
	zIndex: 10,
	transition: "border 0.3s ease",
	pointerEvents: "none",
});

export const threadHistoryToggleButton = (): GriffelStyle => ({
	height: "12px",
	width: "30px",
	backgroundColor: tokens.colorBrandBackground2,
	color: tokens.colorBrandForeground2,
	"&:hover": {
		backgroundColor: tokens.colorBrandBackground2Hover,
		color: tokens.colorBrandForeground2Hover,
	},
});

// Text that is read by assistive technology but not shown. ARIA prohibits naming a generic element, so an
// aria-label on a plain span (what Fluent's Text renders) is invalid and dropped by screen readers; real
// text hidden this way is announced instead.
export const visuallyHidden = (): GriffelStyle => ({
	position: "absolute",
	width: "1px",
	height: "1px",
	overflow: "hidden",
	clipPath: "inset(50%)",
	whiteSpace: "nowrap",
});

// Ring marking a contact that is logged into CC4Teams. Shared by the contact list row avatar and the
// 72px avatar inside the hover card that same row opens, so the two must stay identical.
// A box-shadow rather than a border: a border insets the absolutely positioned avatar image (global
// box-sizing: border-box), and the image circle and the border's inner circle are anti-aliased
// independently, leaving a hairline of the avatar background visible between the photo and the ring.
export const hasClientRing = (): GriffelStyle => ({
	boxShadow: `0 0 0 2px ${tokens.colorBrandBackground}`,
});

export const interactionBarShadow = (): GriffelStyle => ({
	boxShadow: `0 4px 7px 0 ${tokens.colorNeutralShadowKeyLighter}, 0 2px 4px 0 ${tokens.colorNeutralShadowAmbientLighter}`,
});

export const useCommonStyle = makeStyles({
	ellipsis: ellipsis(),
	semiBold: semiBold(),
});
